module.exports = __webpack_public_path__ + "static/media/baseball.3402e185.svg";